import cx from "clsx"
import { Link } from "wouter"
import { ButtonLink } from "../../../components/ButtonLink"
import { HappyLayout } from "../../../components/HappyLayout"
import typography from "@rawa/ui/styles/typography.module.css"
import styles from "./KioskWelcomePage.module.scss"
import SunnyThumbsUp from "../../../assets/sunny-thumbs.svg?react"
import CogIcon from "../../../assets/cog.svg?react"
import { paths } from "../../../paths"

export function KioskWelcomePage() {
  return (
    <HappyLayout
      heading={
        <div className={cx(typography.hero, styles.heading)}>
          Together we'll find a way
        </div>
      }
    >
      <Link
        href={paths.kioskLocation}
        aria-label="Change location"
        className={styles.cog}
      >
        <CogIcon width={24} height={24} aria-hidden={true} />
      </Link>
      <div className={styles.content}>
        <div>
          <h1 className={typography.h1}>Client Feedback</h1>
          <p className={typography.bodyLarge}>
            We would love to hear from you.
          </p>
          <SunnyThumbsUp className={styles.sunny} aria-hidden={true} />
        </div>
        <ButtonLink className={styles.btnReturn} href={paths.kioskSessions}>
          Start
        </ButtonLink>
      </div>
    </HappyLayout>
  )
}
